export default __webpack_public_path__ + "static/media/undraw_creative_team_r90h 1.e26e3e3e.png";